import { FC } from "react"

import type { TCoachingSessionsEntityProps } from "./types"

export { CoachingSessionsEntity } from "./coaching-sessions.entity"
export type {
    TCoachingSessionsEntityProps,
    TCoachingSessionsTimingSessionModalProps,
    TCoachingSessionsModalSimpleProps,
    TCoachingSessionsCancelModalProps
} from "./types"
export { ECoachingSessionsApiMode } from "./types"

async function coachingSessionsEntityLoader(): Promise<{ default: FC<TCoachingSessionsEntityProps> }> {
    return await import("./coaching-sessions.entity").then(
        ({ CoachingSessionsEntity: E }): { default: FC<TCoachingSessionsEntityProps> } => ({ default: E })
    )
}

export { coachingSessionsEntityLoader }
